import { Publisher } from './publisher';
import { Log } from './log';
import { LogLevel } from './log-level';

export class ConsolePublisher implements Publisher {

    publish(log: Log) {
        switch (log.level) {
            case LogLevel.ERROR:
                console.error(log.date, log.msg, log.error);
                break;
            case LogLevel.WARNING:
                console.warn(log.date, log.msg, log.error);
                break;
            case LogLevel.DEBUG:
            case LogLevel.INFO:
                console.log(log.date, log.msg, log.error);
                break;
        }
    }

}
